import { combineReducers } from 'redux'

// ACTIONS
export const FETCH = 'offerzen/profile/FETCH'
export const FETCH_SUCCESS = 'offerzen/profile/FETCH_SUCCESS'

export const UPDATE = 'offerzen/profile/UPDATE'
export const UPDATE_SUCCESS = 'offerzen/profile/UPDATE_SUCCESS'
export const UPDATE_ERROR = 'offerzen/profile/UPDATE_ERROR'

export const UPDATE_IMAGE = 'offerzen/profile/UPDATE_IMAGE'
export const UPDATE_IMAGE_SUCCESS = 'offerzen/profile/UPDATE_IMAGE_SUCCESS'
export const UPDATE_IMAGE_PROGRESS = 'offerzen/profile/UPDATE_IMAGE_PROGRESS'

export const FETCH_IMAGE = 'offerzen/profile/FETCH_IMAGE'
export const FETCH_IMAGE_SUCCESS = 'offerzen/profile/FETCH_IMAGE_SUCCESS'

export const UPDATE_PERSONAL_INFORMATION = 'offerzen/profile/UPDATE_PERSONAL_INFORMATION'
export const TOGGLE_PERSONAL_INFORMATION = 'offerzen/profile/TOGGLE_PERSONAL_INFORMATION'

export const UPDATE_SALARY = 'offerzen/profile/UPDATE_SALARY'
export const UPDATE_OVERALL_EXPERIENCE = 'offerzen/profile/UPDATE_OVERALL_EXPERIENCE'

export const UPDATE_ABOUT = 'offerzen/profile/UPDATE_ABOUT'
export const ABOUT_TOGGLE = 'offerzen/profile/ABOUT_TOGGLE'

export const UPDATE_NEXT_JOB = 'offerzen/profile/UPDATE_NEXT_JOB'
export const NEXT_JOB_TOGGLE = 'offerzen/profile/NEXT_JOB_TOGGLE'

export const HIDE_PROFILE = 'offerzen/profile/HIDE_PROFILE'

export const HIDE_UPDATE_PROFILE_NOTICE = 'offerzen/profile/HIDE_UPDATE_PROFILE_NOTICE'

export const SEARCH_PLACES = 'offerzen/profile/personalInformation/SEARCH_PLACES'
export const SEARCH_PLACES_SUCCESS = 'offerzen/profile/personalInformation/SEARCH_PLACES_SUCCESS'
export const SEARCH_PLACES_ERROR = 'offerzen/profile/personalInformation/SEARCH_PLACES_ERROR'

// ACTION CREATORS
export const fetchProfile = id => ({
  type: FETCH,
  payload: {
    loading: true,
    id,
  },
})

export const fetchProfileImage = id => ({
  type: FETCH_IMAGE,
  payload: {
    loading: true,
    id,
  },
})

export const fetchProfileSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: {
    loading: false,
    data,
  },
})

export const updateProfile = (data, id, resolve, reject) => ({
  type: UPDATE,
  meta: { resolve, reject },
  payload: {
    loading: true,
    data,
    id,
  },
})

export const updatePersonalInformation = (data, id, resolve, reject) => ({
  type: UPDATE_PERSONAL_INFORMATION,
  meta: { resolve, reject },
  payload: {
    loading: true,
    data,
    id,
  },
})

export const togglePersonalInformation = editing => ({
  type: TOGGLE_PERSONAL_INFORMATION,
  payload: { editing },
})

export const updateSalary = (data, id, resolve, reject) => ({
  type: UPDATE_SALARY,
  meta: {
    resolve,
    reject,
  },
  payload: {
    loading: true,
    data,
    id,
  },
})

export const updateOverallExperience = (data, id) => ({
  type: UPDATE_OVERALL_EXPERIENCE,
  payload: {
    loading: true,
    data,
    id,
  },
})

export const updateAboutMe = (data, id, resolve, reject) => ({
  type: UPDATE_ABOUT,
  meta: { resolve, reject },
  payload: {
    loading: true,
    data,
    id,
  },
})

export const aboutToggle = editing => ({
  type: ABOUT_TOGGLE,
  payload: { editing },
})

export const updateNextJob = (data, id, resolve, reject) => ({
  type: UPDATE_NEXT_JOB,
  meta: { resolve, reject },
  payload: {
    loading: true,
    data,
    id,
  },
})

export const nextJobToggle = editing => ({
  type: NEXT_JOB_TOGGLE,
  payload: { editing },
})

export const updateProfileSuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: {
    loading: false,
    data,
  },
})

export const updateProfileError = errorMessage => ({
  type: UPDATE_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const updateProfileImage = (data, id) => ({
  type: UPDATE_IMAGE,
  payload: {
    loading: true,
    data,
    id,
  },
})

export const updateProfileImageSuccess = url => ({
  type: UPDATE_IMAGE_SUCCESS,
  payload: {
    loading: false,
    url,
  },
})

export const updateUploadProgress = (progress, isUploading) => ({
  type: UPDATE_IMAGE_PROGRESS,
  payload: { progress, isUploading },
})

export const fetchProfileImageSuccess = url => ({
  type: FETCH_IMAGE_SUCCESS,
  payload: {
    loading: false,
    url,
  },
})

export const hideShowUpdateProfileNotice = id => ({
  type: HIDE_UPDATE_PROFILE_NOTICE,
  payload: {
    id,
    data: {
      show_update_profile_notice: false,
    },
  },
})

export const hideProfile = (id, data, resolve, reject) => ({
  type: HIDE_PROFILE,
  meta: {
    id,
    data,
    resolve,
    reject,
  },
})

// REDUCERS
const defaultProfile = {
  loading: false,
  primary_role: '',
  employment_types: [],
  call_to_action: null,
  candidate_slug: null,
  current_salary: 0,
  current_state: null,
  employment_preference: null,
  google_place_id: null,
  id: null,
  job_search_status: null,
  location: null,
  marked_as_completed: false,
  name: null,
  notice_period: null,
  overall_years_experience: null,
  preferred_contract_rate: null,
  preferred_salary: null,
  substate: null,
  about_me: null,
  what_next: null,
  transitioned_at: null,
  phone: null,
  whatsapp_number: null,
  show_update_profile_notice: null,
  job_search_last_updated_at: null,
  last_transitioned_in_review_at: null,
  job_search_reasons: [],
  job_search_description: null,
  current_contract_conditions: [],
  notice_period_type: null,
  features: {},
}

const profile = (state = defaultProfile, { type, payload }) => {
  switch (type) {
    case FETCH:
      return {
        ...state,
        loading: payload.loading,
      }

    case FETCH_SUCCESS:
    case UPDATE_SUCCESS:
      return {
        ...state,
        ...payload.data,
        loading: payload.loading,
      }

    case HIDE_UPDATE_PROFILE_NOTICE:
      return {
        ...state,
        ...payload.data,
      }

    default:
      return state
  }
}

const defaultPersonalInformation = {
  loading: false,
  editing: false,

  placesSearchResults: [],
  searchingPlaces: false,
  placesSearchError: null,
}

const personalInformation = (state = defaultPersonalInformation, action) => {
  switch (action.type) {
    case UPDATE_PERSONAL_INFORMATION:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case UPDATE_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case TOGGLE_PERSONAL_INFORMATION:
    case SEARCH_PLACES:
    case SEARCH_PLACES_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }

    case SEARCH_PLACES_ERROR:
      return {
        ...state,
        searchingPlaces: false,
        placesSearchError: action.payload,
      }

    default:
      return state
  }
}

const defaultSalary = {
  loading: false,
  error: null,
}

const salary = (state = defaultSalary, action) => {
  switch (action.type) {
    case UPDATE_SALARY:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case UPDATE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
      }

    default:
      return state
  }
}

const aboutMe = (
  state = {
    editing: false,
  },
  action,
) => {
  switch (action.type) {
    case ABOUT_TOGGLE:
      return {
        ...state,
        editing: action.payload.editing,
      }

    case UPDATE_ABOUT:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case UPDATE_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case UPDATE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }
}

const nextJob = (
  state = {
    editing: false,
  },
  action,
) => {
  switch (action.type) {
    case NEXT_JOB_TOGGLE:
      return {
        ...state,
        editing: action.payload.editing,
      }

    case UPDATE_NEXT_JOB:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case UPDATE_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case UPDATE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }
}

const defaultProfileImage = {
  progress: 0,
  isUploading: false,
  loading: false,
  url: null,
}

const profileImage = (state = defaultProfileImage, action) => {
  switch (action.type) {
    case FETCH_IMAGE_SUCCESS:
    case UPDATE_IMAGE_SUCCESS:
    case UPDATE_IMAGE_PROGRESS:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

const defaultOverallExperience = {
  loading: false,
}

const overallExperience = (state = defaultOverallExperience, action) => {
  switch (action.type) {
    case UPDATE_OVERALL_EXPERIENCE:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case UPDATE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
      }

    default:
      return state
  }
}

const profileReducer = combineReducers({
  salary,
  nextJob,
  aboutMe,
  personalInformation,
  profile,
  profileImage,
  overallExperience,
})

export default profileReducer

export const getCandidateProfile = state => state.views.profile.profile.profile || defaultProfile
export const getProfileImage = state => state.views.profile.profile.profileImage || defaultProfileImage
export const getOverallExperience = state => state.views.profile.profile.overallExperience || defaultOverallExperience
